var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogorrtv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.34 25.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #6660ff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.65,23.73L94.31,1.78h-7.59l-4.8,12.54c-.94,2.63-1.13,3.64-1.13,5.24v.12h-.56v-.12c0-1.6-.19-2.6-1.13-5.24l-4.8-12.54h-7.59l9.66,21.95h8.28ZM58.25,23.73V7.36h8.56V1.78h-23.89v5.58h8.56v16.37h6.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.16,18.53c-2.16,0-3.23-1.1-3.23-2.7s1.07-2.66,3.23-2.66h6.19v-3.98h-3.59c-1.82,0-2.76-.47-3.29-1.76l-2.35-5.64H2.03l1.91,4.17c1.29,2.76,2.7,3.54,5.02,3.61v.56c-3.2.22-5.8,2.98-5.8,6.59,0,4.11,2.89,7.02,9.16,7.02h7.04v-5.2h-6.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.6,6.99c2.16,0,3.23,1.1,3.23,2.7s-1.07,2.66-3.23,2.66h-6.19v3.98h3.59c1.82,0,2.76.47,3.29,1.76l2.35,5.64h8.09l-1.91-4.17c-1.29-2.76-2.7-3.54-5.02-3.61v-.56c3.2-.22,5.8-2.98,5.8-6.59,0-4.11-2.89-7.02-9.16-7.02h-7.04v5.2h6.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogorrtv);
export default __webpack_public_path__ + "static/media/LOGO RR TV.3fb40081166d964b2c7ab9d22343c268.svg";
export { ForwardRef as ReactComponent };